import { type FC, type ReactNode } from "react";
import Modal from "~/common/components/Modal";
import { type NetPriceData } from "~/domains/pricing/types/PriceData";
import AtcProductInfo from "~/features/addToCart/components/AtcProductInfo";
import { IncludesSurchargeDisclaimer } from "~/domains/pricing/components/IncludesSurchargeDisclaimer";
import type { ProductDescriptor } from "~/domains/product/types/ProductDescriptor";

export interface ATWPopupBaseProps {
  children?: ReactNode;
  product: ProductDescriptor;

  price: NetPriceData | null;

  quantity: number;
  onQtyChange: (newQty: number) => void;

  priceReference: string;
  onPriceReferenceChange?: (newValue: string | undefined) => void;

  editable: boolean;
  disabled: boolean;

  onClose: () => void;
  footerChildren?: ReactNode;
  isDesktop: boolean;
}

const ATWPopupBase: FC<ATWPopupBaseProps> = (props) => {
  const {
    onClose,
    onQtyChange,
    quantity,
    product,
    editable,
    disabled,
    priceReference,
    onPriceReferenceChange,
    isDesktop,
    price,
  } = props;
  return (
    <Modal onClose={onClose} footerChildren={props.footerChildren}>
      <div className="scha__atc-popup">
        <div className="scha__atc-popup--column-info">
          <AtcProductInfo
            variant={"ATW"}
            descriptor={product}
            quantity={quantity}
            price={price}
            priceUnit={price?.unit ?? 1}
            onChange={onQtyChange}
            disabled={!editable || disabled}
            priceReference={priceReference}
            onPriceReferenceChange={onPriceReferenceChange}
            isSpecialPrice={price?.isSpecial}
            hasSurcharge={!!price?.surcharge}
          />
        </div>
        <div className="scha__atc-popup--column-packaging">{props.children}</div>
      </div>
      {
        <IncludesSurchargeDisclaimer
          hasSurcharge={!!price?.surcharge}
          className={"scha__add-to-wishlist__has-surcharge"}
        />
      }
    </Modal>
  );
};

export default ATWPopupBase;
